/**
 * Мобильная навигация §59: Создать → Проекты → Медиа → Персона → Меню.
 */
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Menu } from 'lucide-react';
import { useUiStore } from '../../stores/ui';
import { mobileNav } from './navigation';

export function MobileNav() {
  const { t } = useTranslation();
  const toggle = useUiStore((state) => state.toggleMobileNav);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-line bg-surface pb-[env(safe-area-inset-bottom)] lg:hidden">
      {mobileNav.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              clsx(
                'flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] transition-colors duration-fast',
                isActive ? 'text-content' : 'text-content-muted',
              )
            }
          >
            <Icon className="h-5 w-5" strokeWidth={1.75} />
            {t(item.labelKey)}
          </NavLink>
        );
      })}
      <button
        type="button"
        onClick={toggle}
        className="flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] text-content-muted"
      >
        <Menu className="h-5 w-5" strokeWidth={1.75} />{t('nav.menu')}</button>
    </nav>
  );
}
